export const RegionalOperatorInvoices = 'RegionalOperatorInvoices'
export const Appeals = 'Appeals'
export const Waybills = 'Waybills'
export const WaybillsTasks = 'WaybillsTasks'
export const WaybillsOutages = 'WaybillsOutages'
export const WaybillsPayments = 'WaybillsPayments'
export const WaybillsReportTasks = 'WaybillsReportTasks'
export const WaybillsReportRoutes = 'WaybillsReportRoutes'
export const CalculationRegionalTariffs = 'CalculationRegionalTariffs'
export const SourcesWasteSources = 'SourcesWasteSources'
export const SourcesWasteSourcesLegalEntity = 'SourcesWasteSourcesLegalEntity'
export const SourcesWasteSourcesIndividual = 'SourcesWasteSourcesIndividual'
export const SourcesWasteSourcesMSN = 'SourcesWasteSourcesMSN'
export const SourcesWasteSourcesOperator = 'SourcesWasteSourcesOperator'
export const SourcesWasteSourcesGarbage = 'SourcesWasteSourcesGarbage'
export const RegistryOperatorTransport = 'RegistryOperatorTransport'
export const RegistryOperatorTransportMaintenance = 'RegistryOperatorTransportMaintenance'
export const StaffManagementEmployees = 'StaffManagementEmployees'

export const NavigationControlRoute = 'NavigationControlRoute'
export const RoutesRoutes = 'RoutesRoutes'
export const RoutesSchedule = 'RoutesSchedule'
